<styles-message-container alignment="left">
  <div class="message-content viewer">
    <framework-person-image [person]="typing" size="60px"> </framework-person-image>
    <styles-message-box
      speech="left"
      titleHeader="{{typing?.displayName}}"
      titleComment="is typing"
      icon="format_quote"
    >
      <div class="lightui1-shimmer"></div>
      <div class="lightui1-shimmer footer"></div>
    </styles-message-box>
  </div>
</styles-message-container>
